import { StripeElementChangeEvent } from '@stripe/stripe-js';
import { useCallback, useState } from 'react';

const ERROR_MESSAGES = {
  // Number
  incomplete_number: getText('Your card number is incomplete.'),
  invalid_number: getText('Your card number is invalid.'),
  // Expiry
  incomplete_expiry: getText(`Your card's expiration date is incomplete.`),
  invalid_expiry_year: getText(`Your card's expiration year is invalid.`),
  invalid_expiry_year_past: getText(`Your card's expiration year has passed.`),
  // CVC
  incomplete_cvc: getText(`Your card's security code is incomplete.`),
};

type StripeFieldStatus =
  | { type: 'empty' }
  | { type: 'complete' }
  | { type: 'error'; errorMessage: string };

export function useStripeFieldStatus(): [
  StripeFieldStatus,
  (event: StripeElementChangeEvent) => void,
] {
  const [status, setStatus] = useState<StripeFieldStatus>({
    type: 'empty',
  });

  const onChange = useCallback((event: StripeElementChangeEvent) => {
    if (event.error) {
      setStatus({
        type: 'error',
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        errorMessage: ERROR_MESSAGES[event.error.code] || event.error.message,
      });
    } else if (event.complete) {
      setStatus({ type: 'complete' });
    } else {
      setStatus({ type: 'empty' });
    }
  }, []);

  return [status, onChange];
}
